module.exports = __webpack_public_path__ + "img/position-pending.95936459.svg";